import { useFluxStore } from "@evertrue/et-flux";
import SessionStore from "apps/auth/stores/session-store";
import OrgStore from "apps/auth/stores/org-store";

const sessionStoreMapState = () => ({
  session: SessionStore.getSession(),
});

const orgStoreMapState = () => ({
  org: OrgStore.getCurrentOrg(),
});

export const useIdentity = () => {
  const { session = {} } = useFluxStore(SessionStore, sessionStoreMapState);
  const { org = {} } = useFluxStore(OrgStore, orgStoreMapState);
  return { user: session.user, session, org };
};

export default useIdentity;
